import React from 'react';

import { Switch, Route } from 'react-router-dom';

import { OrderDetail } from './detail/detail';
import { OrderList } from './list/list';

export function Orders({ path }) {
    return (
        <Switch>
            <Route exact path={path}>
                <OrderList />
            </Route>

            <Route exact path={`${path}/:order_id`}>
                <OrderDetail />
            </Route>
        </Switch>
    );
}
